export const REVIEW_TYPES = {
  SEQUENTIAL: 'Sequential',
  PARALLEL: 'Parallel'
};

export const getReviewTypeColor = (type) => {
  switch (type) {
    case REVIEW_TYPES.SEQUENTIAL:
      return '#EBF5FF'; // Light blue background
    case REVIEW_TYPES.PARALLEL:
      return '#E2F8E9'; // Light green background
    default:
      return '#F1F5F9'; // Light slate background
  }
};

export const getReviewTypeText = (type) => {
  switch (type) {
    case REVIEW_TYPES.SEQUENTIAL:
      return 'Sequential';
    case REVIEW_TYPES.PARALLEL:
      return 'Parallel';
    default:
      return 'Unknown Type';
  }
};

export const getReviewTypeBorderColor = (type) => {
  switch (type) {
    case REVIEW_TYPES.SEQUENTIAL:
      return '#2E90FA'; // Blue border
    case REVIEW_TYPES.PARALLEL:
      return '#16A34A'; // Green border
    default:
      return '#475569'; // Slate border
  }
};

export const getReviewTypeTextColor = (type) => {
  switch (type) {
    case REVIEW_TYPES.SEQUENTIAL:
      return '#1D4ED8'; // Darker blue text
    case REVIEW_TYPES.PARALLEL:
      return '#15803D'; // Darker green text
    default:
      return '#1E293B'; // Darker slate text
  }
}; 